import horizontalTop1 from "./assets/dea/horizontal/5_tw_DEA_horizontal_top.jpg";
import horizontalBottom1 from "./assets/dea/horizontal/5_tw_DEA_horizontal_bottom.jpg";

import horizontalTop2 from "./assets/dea/horizontal/6_tw_DEA_horizontal_top.jpg";
import horizontalBottom2 from "./assets/dea/horizontal/6_tw_DEA_horizontal_bottom.jpg";

import horizontalTop3 from "./assets/dea/horizontal/7_tw_DEA_horizontal_top.jpg";
import horizontalBottom3 from "./assets/dea/horizontal/7_tw_DEA_horizontal_bottom.jpg";

import horizontalTop4 from "./assets/dea/horizontal/8_tw_DEA_horizontal_top.jpg";
import horizontalBottom4 from "./assets/dea/horizontal/8_tw_DEA_horizontal_bottom.jpg";

import horizontalTop5 from "./assets/dea/horizontal/9_tw_DEA_horizontal_top.jpg";
import horizontalBottom5 from "./assets/dea/horizontal/9_tw_DEA_horizontal_bottom.jpg";

import horizontalTop6 from "./assets/dea/horizontal/10_tw_DEA_horizontal_top.jpg";
import horizontalBottom6 from "./assets/dea/horizontal/10_tw_DEA_horizontal_bottom.jpg";

import squareTopPeacock from "./assets/dea/square/1_tw_DEA_square_top.jpg";
import squareBottomPeacock from "./assets/dea/square/1_tw_DEA_square_bottom.jpg";

import squareTopFish from "./assets/dea/square/2_tw_DEA_square_top.jpg";
import squareBottomFish from "./assets/dea/square/2_tw_DEA_square_bottom.jpg";

import squareTopSky from "./assets/dea/square/3_tw_DEA_square_top.jpg";
import squareBottomSky from "./assets/dea/square/3_tw_DEA_square_bottom.jpg";

import squareTopColor from "./assets/dea/square/4_tw_DEA_square_top.jpg";
import squareBottomColor from "./assets/dea/square/4_tw_DEA_square_bottom.jpg";

const images = {
  illustration1: horizontalBottom1,
  illustration2: horizontalBottom2,
  illustration3: horizontalBottom3,
  illustration4: horizontalBottom4,
  illustration5: horizontalBottom5,
  illustration6: horizontalBottom6,
  fbLogo1: horizontalTop1,
  fbLogo2: horizontalTop2,
  fbLogo3: horizontalTop3,
  fbLogo4: horizontalTop4,
  fbLogo5: horizontalTop5,
  fbLogo6: horizontalTop6,
  igIllustration1: squareTopPeacock,
  igLogo1: squareBottomPeacock,
  igIllustration2: squareTopFish,
  igLogo2: squareBottomFish,
  igIllustration3: squareTopSky,
  igLogo3: squareBottomSky,
  igIllustration4: squareTopColor,
  igLogo4: squareBottomColor,
  dea: true,
};

export default images;
